module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/frontmatter01#frontmatter01"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01#part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APPETIZERS AND DIPS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter01#part01chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Deviled Eggs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter02#part01chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Mushroom Bruschetta")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter03#part01chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Baked Spinach Balls")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter04#part01chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Two-Bean Spread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter05#part01chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Eggplant Dip")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter06#part01chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Roasted Zucchini and Garlic Spread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter07#part01chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("California Wraps")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part01chapter08#part01chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Mushrooms Stuffed with Orzo")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SALADS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter01#part02chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10-Layer Salad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart02chapter01section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter01#part02chapter01section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Herbed Sour Cream Dressing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter02#part02chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Greek Salad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter03#part02chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cactus Salad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart02chapter03section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter03#part02chapter03section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Lime Dressing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter04#part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Coleslaw")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter05#part02chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Spinach and Melon Salad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart02chapter05section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter05#part02chapter05section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Honey Dressing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part02chapter06#part02chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wilted Spinach Salad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SOUPS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter01#part03chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Dilled Beet Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter02#part03chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Black Bean Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter03#part03chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Herbed Cucumber Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter04#part03chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tortilla Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter05#part03chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tortellini and Mushroom Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter06#part03chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wonton Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart03chapter06section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter06#part03chapter06section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Vegetable-Filled Wontons")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part03chapter07#part03chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Pumpkin Soup")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BEEF STEWS AND ENTRÉES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter01#part04chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Beef Satay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter02#part04chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Beef and Ancho Chili Stew")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter03#part04chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Shish Kebabs")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter04#part04chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Just Plain Meat Loaf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter04section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter04#part04chapter04section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stuffed Green Peppers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter04section02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter04#part04chapter04section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Italian Meat Loaf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter04section03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter04#part04chapter04section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Savory Cheese Meat Loaf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter04section04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter04#part04chapter04section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chutney–Peanut Meat Loaf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter05#part04chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Beef Steaks with Tomatillo and Avocado Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter05section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter05#part04chapter05section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tomatillo Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter06#part04chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Steak au Poivre")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter06section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter06#part04chapter06section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Crumb-Crusted Roast Beef")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter07#part04chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Flank Steak on Salad Greens")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter07section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter07#part04chapter07section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Grilled Lamb on Salad Greens")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part04chapter08#part04chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Soft Tacos")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart05"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part05#part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("POULTRY STEWS AND ENTRÉES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter01#part05chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chicken with Gingered Honey-Orange Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart05chapter01section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter01#part05chapter01section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Gingered Honey-Orange Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter02#part05chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BBQ Chicken Breasts")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter03#part05chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("California No-Bean Chili")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter04#part05chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chicken Breasts with Rosemary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter05#part05chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Arroz con Pollo")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter06#part05chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chicken Cordon Bleu")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter07#part05chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Oven-Fried Chicken Drumsticks")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart05chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter08#part05chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chicken and Cheese Rellenos")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart05chapter08section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part05chapter08#part05chapter08section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chili Tomato Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06#part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("FISH AND SEAFOOD ENTRÉES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter01#part06chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Crab Cakes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter02#part06chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Scallops with Asparagus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter03#part06chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Scallops with Apples and Pea Pods")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter04#part06chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Braised Fish with Sun-Dried Tomato Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter05#part06chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Flounder en Papillote")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter06#part06chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Halibut with Couscous")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter07#part06chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Halibut with Sour Cream and Poblano Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart06chapter07section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter07#part06chapter07section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Sour Cream and Poblano Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter08#part06chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Teriyaki Salmon Burgers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart06chapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part06chapter09#part06chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Red Snapper Baked with Cilantro")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part07#part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SAUCES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart07chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part07chapter01#part07chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10-Minute Spaghetti Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart07chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part07chapter02#part07chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Rustic Tomato Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart07chapter03"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part07chapter03#part07chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Barbecue Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart07chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part07chapter04#part07chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Thai Peanut Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08#part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SIDE DISHES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter01#part08chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Broccoli Rabe Sautéed with Garlic")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter02#part08chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cauliflower with Creamy Cheese Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart08chapter02section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter02#part08chapter02section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Creamy Cheese Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter03#part08chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Greek-Style Green Beans")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter04#part08chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Asparagus with Lemon-Wine Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter05#part08chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Mushrooms with Sour Cream")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter06#part08chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Honey-Glazed Roasted Beets")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter07#part08chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Eggplant and Vegetable Sauté")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart08chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part08chapter08#part08chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Fried Brown Rice")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09#part09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BREADS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter01#part09chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cheddar Biscuits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter02#part09chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Corn Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter03#part09chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Squash Dinner Rolls")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart09chapter03section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter03#part09chapter03section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Raisin–Walnut Pumpkin Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter04#part09chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Roasted Red Pepper Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter05#part09chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Banana Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart09chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part09chapter06#part09chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Multigrain Batter Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10#part10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("DESSERTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter01#part10chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Best Brownies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter02#part10chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Strawberry Shortcake")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter03#part10chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Strawberry Cream Pie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter03section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter03#part10chapter03section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Double Berry Pie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter03section02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter03#part10chapter03section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Strawberry–Banana Pie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter04"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/part10chapter04#part10chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chocolate Yogurt Pie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter05#part10chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Lemon Pie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter05section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter05#part10chapter05section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Graham Cracker Crust")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter06#part10chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Biscotti")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter07#part10chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Orange Meringue Cookies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter08#part10chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chocolate Chip Cookies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter09#part10chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Soft Molasses Cookies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter10#part10chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tart Lemon Dainties")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter11#part10chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Granola Lace Cookies")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter12#part10chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Raspberry–Almond Bars")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter13#part10chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Banana–Chocolate Sherbet")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter14#part10chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Pumpkin Cheesecake")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter15#part10chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cheesecake Cupcakes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter15section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter15#part10chapter15section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cheesecake Topping")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter16#part10chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Old-Fashioned Apple Crisp")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter16section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter16#part10chapter16section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Crispy Spiced Topping")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart10chapter17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter17#part10chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Baked Custard with Orange Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter17section01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter17#part10chapter17section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Orange Sauce")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart10chapter17section02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/part10chapter17#part10chapter17section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Baked Chocolate Custard")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/backmatter01#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/backmatter02#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT THE SERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rbackmatter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/backmatter03#backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT THE EDITOR")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0